import React, { useEffect, useRef } from 'react';
import { StageScreen } from './components/StageShell';

async function loadChartJs() {
  if (window.Chart) return window.Chart;
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/chart.js';
    s.onload = () => resolve(window.Chart);
    s.onerror = reject;
    document.head.appendChild(s);
  });
}

export default function Stage4Graph({ ranking, stagesData, pagesBg, onNext }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  const top5 = (ranking || [])
    .filter(Boolean)
    .slice(0, 5)
    .map((item, i) => ({
      label: item?.text || item?.label || String(item),
      rank: i + 1,
    }));

  useEffect(() => {
    let mounted = true;

    loadChartJs().then((Chart) => {
      if (!mounted || !canvasRef.current) return;
      chartRef.current = new Chart(canvasRef.current, {
        type: 'bar',
        data: {
          labels: top5.map((c) => c.label),
          datasets: [{
            label: 'Average Rank',
            data: top5.map((c) => c.rank),
            backgroundColor: 'rgba(54, 162, 235, 0.7)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 2,
          }],
        },
        options: {
          responsive: true,
          scales: {
            x: {
              ticks: { color: '#ffffff' },
              grid: { color: 'rgba(255,255,255,0.1)' },
            },
            y: {
              ticks: { color: '#ffffff', stepSize: 1 },
              grid: { color: 'rgba(255,255,255,0.1)' },
              beginAtZero: true,
            },
          },
          plugins: {
            legend: { labels: { color: '#ffffff' } },
          },
        },
      });
    }).catch(() => {});

    return () => {
      mounted = false;
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const stage4 = stagesData?.stage_4 || {};

  return (
    <StageScreen pagesBg={pagesBg} pageKey="stage_4" stage={stage4}>
      <div className="fi-stage-root fi-graph-root">
        <h2 className="fi-heading fi-graph-title">
          {stage4?.graph_heading || 'Top 5 Countries'}
        </h2>
        <div className="fi-graph-container">
          <div className="fi-graph-chart-wrap">
            <canvas ref={canvasRef} />
          </div>
        </div>
        <div className="fi-actions">
          <button type="button" className="fi-btn fi-btn--primary" onClick={onNext}>
            Next
          </button>
        </div>
      </div>
    </StageScreen>
  );
}
